import {
  QuerySetType,
  DatasetType,
  FunctionType,
  RelationshipType,
  ReconsetBasicType,
  AdditionalColumn,
} from "@supportinitiative/common";

import { ActionOptionsType } from "../../types";

export function getActionOptions(
  currentAction: string,
  prevValues: QuerySetType | undefined,
  currentValues: QuerySetType | undefined,
  applicationState: any,
): ActionOptionsType {
  switch (currentAction.toUpperCase()) {
    case "NEW": {
      return {
        allowedActions: ["save", "cancel"],
        disableAll: false,
      };
    }
    case "VIEW": {
      let actionOptions: { allowedActions: string[]; disableAll: boolean } = {
        allowedActions: [],
        disableAll: true,
      };

      actionOptions.allowedActions.push("modifications");

      if (
        currentValues?.authStatus === "UNAUTH" &&
        currentValues?.modificationNo === 1 &&
        currentValues?.makerId === applicationState.user.userId
      ) {
        actionOptions.allowedActions.push("delete");
      }

      if (currentValues?.authStatus === "UNAUTH" && currentValues?.makerId !== applicationState.user.userId) {
        actionOptions.allowedActions.push("auth");
      } else {
        actionOptions.allowedActions.push("edit");
      }

      actionOptions.allowedActions.push("back");
      return actionOptions;
    }
    case "EDIT": {
      return {
        allowedActions: ["save", "cancel"],
        disableAll: false,
      };
    }
    default:
      return { allowedActions: [], disableAll: true };
  }
}

export const SECTIONCOLORS = [
  "oklch(1.01 0 0)",
  "#F5F7F8",
  "oklch(98.5% 0 0)",
  "oklch(98.5% 0 0)",
  "oklch(98.5% 0.001 106.423)",
  "#FBFFFF",
];
